export const USER_LIST_HEADERS = ["Username", "Group", "Roles", ""];
export const DELETE_API_RESPONSE = "User Removed";
export const DELETE_USER_SUCCESS_MSG = "User has been deleted successfully";
export const API_FAILED_MSG = "Something went wrong";
